import React from 'react';

export const NoDataContentInTable = ({ ariaLabel, testId }: { ariaLabel?: string; testId?: string }) => {
  const dataTestId = testId ?? 'not-applicable';
  return (
    <span data-testid={dataTestId} aria-label={ariaLabel ?? 'Not applicable or available'}>
      -
    </span>
  );
};
